var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.detail.cancelType == 0
    ? _c(
        "div",
        { staticClass: "flex-auto flex flex-column items-center right" },
        [
          _c(
            "div",
            {
              staticClass:
                "flex text-center flex-item justify-between relative progress",
              staticStyle: { margin: "0 auto" }
            },
            [
              _vm.detail.refundStatus == "FEFUND_SUCC"
                ? [
                    _c("div", { staticClass: "absolute line-wrap" }),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex relative items-center flex-column item"
                      },
                      [
                        _c("img", {
                          staticClass: "radius100 wh56",
                          attrs: {
                            src: require("../../order/detail/images/finish.png")
                          }
                        }),
                        _c("div", { staticClass: "f14" }, [_vm._v("提交订单")]),
                        _c("div", { staticClass: "f12 gray6" }, [
                          _vm._v(_vm._s(_vm.detail.orderTime))
                        ])
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex relative items-center flex-column item"
                      },
                      [
                        _c("img", {
                          staticClass: "radius100 wh56",
                          attrs: {
                            src: require("../../order/detail/images/finish.png")
                          }
                        }),
                        _c("div", { staticClass: "f14" }, [_vm._v("付款成功")]),
                        _c("div", { staticClass: "f12 gray6" }, [
                          _vm._v(_vm._s(_vm.detail.paymentTime))
                        ])
                      ]
                    ),
                    _vm._m(0)
                  ]
                : [
                    _c("div", { staticClass: "absolute line-wrap" }),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex relative items-center flex-column item"
                      },
                      [
                        _c("img", {
                          staticClass: "radius100 wh56",
                          attrs: {
                            src: require("../../order/detail/images/finish.png")
                          }
                        }),
                        _c("div", { staticClass: "f14" }, [_vm._v("提交订单")]),
                        _c("div", { staticClass: "f12 gray6" }, [
                          _vm._v(_vm._s(_vm.detail.orderTime))
                        ])
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex relative items-center flex-column item"
                      },
                      [
                        _vm.detail.orderStatus > 1
                          ? _c("img", {
                              staticClass: "radius100 wh56",
                              attrs: {
                                src: require("../../order/detail/images/finish.png")
                              }
                            })
                          : [
                              _c("img", {
                                staticClass: "radius100 wh56",
                                attrs: {
                                  src: require("../../order/detail/images/progress.png")
                                }
                              }),
                              _c(
                                "div",
                                { staticClass: "absolute white f18 num" },
                                [_vm._v("2")]
                              )
                            ],
                        _c("div", { staticClass: "f14" }, [_vm._v("付款成功")]),
                        _c("div", { staticClass: "f12 gray6" }, [
                          _vm._v(_vm._s(_vm.detail.paymentTime))
                        ])
                      ],
                      2
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex relative items-center flex-column item"
                      },
                      [
                        _vm.detail.delivery != 2
                          ? [
                              _vm.detail.orderStatus > 2
                                ? _c("img", {
                                    staticClass: "radius100 wh56",
                                    attrs: {
                                      src: require("../../order/detail/images/finish.png")
                                    }
                                  })
                                : [
                                    _c("img", {
                                      staticClass: "radius100 wh56",
                                      attrs: {
                                        src: require("../../order/detail/images/progress.png")
                                      }
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "absolute white f18 num" },
                                      [_vm._v("3")]
                                    )
                                  ]
                            ]
                          : _vm._e(),
                        _vm.detail.delivery == 2
                          ? [
                              _vm.detail.orderStatus > 2 &&
                              (_vm.detail.orderTransportDtlBo.pickupTime ||
                                _vm.detail.orderTransportDtlBo
                                  .sellerConfirmPickupTime)
                                ? _c("img", {
                                    staticClass: "radius100 wh56",
                                    attrs: {
                                      src: require("../../order/detail/images/finish.png")
                                    }
                                  })
                                : [
                                    _c("img", {
                                      staticClass: "radius100 wh56",
                                      attrs: {
                                        src: require("../../order/detail/images/progress.png")
                                      }
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "absolute white f18 num" },
                                      [_vm._v("3")]
                                    )
                                  ]
                            ]
                          : _vm._e(),
                        _c("div", { staticClass: "f14" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.delivery == "2"
                                ? "买家自提"
                                : "卖家发货"
                            )
                          )
                        ]),
                        _vm.detail.delivery == 1
                          ? _c("div", { staticClass: "f12 gray6" }, [
                              _vm._v(_vm._s(_vm.detail.sendTime))
                            ])
                          : _vm._e(),
                        _vm.detail.delivery == 2
                          ? _c("div", { staticClass: "f12 gray6" }, [
                              !_vm.detail.orderTransportDtlBo.selfPickupTimeType
                                ? _c(
                                    "div",
                                    { staticClass: "flex-auto mar10-b" },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.detail.orderTransportDtlBo
                                              .pickupTime
                                          ) +
                                          "\n          "
                                      )
                                    ]
                                  )
                                : _vm.detail.orderTransportDtlBo
                                    .sellerConfirmPickupTime
                                ? _c(
                                    "div",
                                    { staticClass: "flex-auto mar10-b" },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.detail.orderTransportDtlBo
                                              .sellerConfirmPickupTimeStr
                                          ) +
                                          "\n            " +
                                          _vm._s(
                                            _vm.detail.orderTransportDtlBo
                                              .sellerConfirmPickupPeriod
                                          ) +
                                          "\n          "
                                      )
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "flex-auto mar10-b" },
                                    [
                                      _vm.detail.orderTransportDtlBo
                                        .pressConfirmType == 0 ||
                                      _vm.detail.orderTransportDtlBo
                                        .pressConfirmType == 1
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "mini"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.pressConfirmOrder(
                                                        _vm.detail.orderId
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("催确认")]
                                              )
                                            ],
                                            1
                                          )
                                        : _c("vid", [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s("待卖家确认") +
                                                "\n            "
                                            )
                                          ])
                                    ],
                                    1
                                  )
                            ])
                          : _vm._e()
                      ],
                      2
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex relative items-center flex-column item"
                      },
                      [
                        _vm.detail.orderStatus > 3
                          ? _c("img", {
                              staticClass: "radius100 wh56",
                              attrs: {
                                src: require("../../order/detail/images/finish.png")
                              }
                            })
                          : [
                              _c("img", {
                                staticClass: "radius100 wh56",
                                attrs: {
                                  src: require("../../order/detail/images/progress.png")
                                }
                              }),
                              _c(
                                "div",
                                { staticClass: "absolute white f18 num" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.detail.orderTransportDtlBo
                                          .sellerConfirmPickupPeriod
                                      ) +
                                      "\n          "
                                  )
                                ]
                              )
                            ],
                        _c("div", { staticClass: "f14" }, [_vm._v("完成")])
                      ],
                      2
                    )
                  ]
            ],
            2
          ),
          _vm.detail.deliveryModify && _vm.detail.deliveryModify.money
            ? _c("div", { staticClass: "mar30-t" }, [
                _c("div", { staticClass: "fb f15" }, [
                  _vm._v("\n      订单涉及商品调整，产生退款"),
                  _c("span", { staticClass: "red pad5-lr" }, [
                    _vm._v("￥" + _vm._s(_vm.detail.deliveryModify.money))
                  ]),
                  _vm._v("订单完成后，将退还至您的"),
                  _c("span", { staticClass: "red pad5-lr" }, [
                    _vm._v("付款账户/预付款账户")
                  ]),
                  _vm._v("，请注意查收\n    ")
                ]),
                _c(
                  "div",
                  {
                    staticClass: "mar5-t pointer gray6",
                    on: {
                      click: function($event) {
                        return _vm.$refs.deliveryModifyRef.open(
                          _vm.detail.deliveryModify.refundGoodsList
                        )
                      }
                    }
                  },
                  [_vm._v("调整明细 >")]
                )
              ])
            : _vm._e(),
          _c("DeliveryModify", { ref: "deliveryModifyRef" }),
          _vm.detail.orderTransportDtlBo &&
          _vm.detail.orderTransportDtlBo.pickupTimeStartDate
            ? _c("div", [
                _vm._v(
                  "\n    提货期限：" +
                    _vm._s(_vm.detail.orderTransportDtlBo.pickupTimeStartDate) +
                    " - " +
                    _vm._s(_vm.detail.orderTransportDtlBo.pickupTimeEndDate) +
                    "\n  "
                )
              ])
            : _vm._e()
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "flex text-center justify-center flex-auto right" },
        [
          _c(
            "div",
            {
              staticClass: "flex flex-item justify-between relative progress",
              staticStyle: { width: "340px" }
            },
            [
              _c("div", { staticClass: "absolute line-wrap" }),
              _c(
                "div",
                { staticClass: "flex relative items-center flex-column item" },
                [
                  _c("img", {
                    staticClass: "radius100 wh56",
                    attrs: {
                      src: require("../../order/detail/images/finish.png")
                    }
                  }),
                  _c("div", { staticClass: "f14" }, [_vm._v("提交订单")]),
                  _c("div", { staticClass: "f12 gray6" }, [
                    _vm._v(_vm._s(_vm.detail.orderTime))
                  ])
                ]
              ),
              _c(
                "div",
                { staticClass: "flex relative items-center flex-column item" },
                [
                  _c("img", {
                    staticClass: "radius100 wh56",
                    attrs: {
                      src: require("../../order/detail/images/finish.png")
                    }
                  }),
                  _c("div", { staticClass: "f14" }, [_vm._v("订单取消成功")]),
                  _c("div", { staticClass: "f12 gray6" }, [
                    _vm._v(_vm._s(_vm.detail.cancleTime))
                  ])
                ]
              )
            ]
          )
        ]
      )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex relative items-center flex-column item" },
      [
        _c("img", {
          staticClass: "radius100 wh56",
          attrs: { src: require("../../order/detail/images/finish.png") }
        }),
        _c("div", { staticClass: "f14" }, [_vm._v("退款成功")])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }